
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSOrderAddressGrid extends Serenity.EntityGrid<POSOrderAddressRow, any> {
        protected getColumnsKey() { return 'Retail.POSOrderAddress'; }

        protected getIdProperty() { return POSOrderAddressRow.idProperty; }
        protected getInsertPermission() { return POSOrderAddressRow.insertPermission; }
        protected getLocalTextPrefix() { return POSOrderAddressRow.localTextPrefix; }
        protected getService() { return POSOrderAddressService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}